import React, { Component } from 'react';
import { compose } from 'redux';
import { reduxForm, Field, getFormValues, change } from 'redux-form';
import { connect } from 'react-redux';

import { bookingFormInitialValues } from '../store/reducers';
import { setStep } from '../store/actions';
import { getPackageTotalPrice, getRoomOfferByRoomTypeId } from '../apiHelpers';
import withLocalize, { addNonBreakingSpaces } from '../withLocalize';
import PackageGallery from './PackageGallery';
import T from './Translate';

class Step3 extends Component {

	componentWillMount() {
		this.props.dispatch(setStep(3));
	}

	getAvailablePackages = (roomTypeId) => {
		const { packages, packageIds } = this.props;
		const numericRoomTypeId = String(roomTypeId).startsWith('_') ? roomTypeId : parseInt(roomTypeId, 10);

		return Object.values(packages)
			.filter(pkg => !packageIds || packageIds.includes(pkg.id))
			.filter(pkg => !pkg.roomTypeIds || pkg.roomTypeIds.includes(numericRoomTypeId));
	};

	render() {
		const {
			formValues,
			roomOffers,
			noOfNights,
			translate: t,
			translatePropertyValue,
		} = this.props;

		return (
			<section className="container">
				{Object.entries(formValues.rooms).map(([roomTypeId, rooms]) => {
					if (!rooms || !rooms.length) return null;

					const availablePackages = this.getAvailablePackages(roomTypeId);
					if (!availablePackages.length) return null;

					const roomOffer = getRoomOfferByRoomTypeId(roomTypeId, roomOffers);

					return rooms.map((room, roomIndex) => {
						const selectedPackage = room && room.package ? String(room.package) : '';

						return (
							<fieldset className="fieldset" key={`${roomTypeId}-${roomIndex}`}>
								<legend>
									<T id="Step3.packages.title" />
									{roomOffer && <span> – {addNonBreakingSpaces(translatePropertyValue(roomOffer.name))}</span>}
								</legend>
								<div className="step3-packages">
									{availablePackages.map(pkg => {
										const fieldName = `rooms[${roomTypeId}][${roomIndex}][package]`;
										const isSelected = selectedPackage === String(pkg.id);

										return (
											<div className={`step3-package${isSelected ? ' step3-package--selected' : ''}`} key={pkg.id}>
												{pkg.photos && pkg.photos.length > 0 &&
												<PackageGallery
													id={pkg.id}
													photos={pkg.photos}
													alt={translatePropertyValue(pkg.name)}
												/>
												}
												<div
													className="step3-package__content"
													onClick={() => this.props.dispatch(change('bookingForm', fieldName, isSelected ? '' : String(pkg.id)))}
												>
													<h3 className="step3-package__name">{translatePropertyValue(pkg.name)}</h3>
													{pkg.description && translatePropertyValue(pkg.description) &&
													<p className="step3-package__description">{translatePropertyValue(pkg.description)}</p>
													}
													<div className="step3-package__price">
														{getPackageTotalPrice(pkg, noOfNights, formValues.currency)}
														{pkg.daily && <span className="step3-package__price-note"> / {t('Step3.packages.perStay')}</span>}
														{pkg.perGuest && <span className="step3-package__price-note"> / {t('Step3.packages.perGuest')}</span>}
													</div>
													<Field
														component="input"
														type="radio"
														name={fieldName}
														value={String(pkg.id)}
														format={v => v ? String(v) : ''}
													/>
													<span className="step3-package__select-label">
														{isSelected ? t('Step3.packages.selected') : t('Step3.packages.select')}
													</span>
												</div>
											</div>
										);
									})}
								</div>
							</fieldset>
						);
					});
				})}
			</section>
		);
	}
}

export default compose(
	reduxForm({
		form: 'bookingForm',
		initialValues: bookingFormInitialValues,
		destroyOnUnmount: false,
	}),
	connect((state) => ({
		formValues: getFormValues('bookingForm')(state),
		packages: state.app.packages || {},
		packageIds: state.app.apiRoomsResponse ? state.app.apiRoomsResponse.packageIds : null,
		roomOffers: state.app.roomOffers,
		noOfNights: state.app.noOfNights,
	})),
	withLocalize,
)(Step3);



// WEBPACK FOOTER //
// ./src/components/Step3.jsx